import MoreVertIcon from '@mui/icons-material/MoreVert';
import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const MoreVertIconStyled = styled(MoreVertIcon)(() => ({
  color: theme.palette.common.white,
}));

export const PaperPropsStyle = {
  style: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.common.white,
    border: '1px solid white',
    borderRadius: '0.5rem',
    maxWidth: '35rem',
  },
};
